import React from 'react';
import clsx from 'clsx';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {CommonRuleEditorProps} from '../../../types';
import {
	expirationRuleEditorClasses,
	getExpirationRuleEditorUtilityClass,
	ExpirationRuleEditorClasses,
	EXPIRATION_RULE_EDITOR_CLASS_NAME,
} from './expirationRuleEditorClasses';

export type ExpirationRuleEditorOwnerState = WithClasses<
	ExpirationRuleEditorClasses,
	{}
>;

const useUtilityClasses = (ownerState: ExpirationRuleEditorOwnerState) => {
	const {classes} = ownerState;
	const slots = {
		root: ['root'],
	};
	return composeClasses(slots, getExpirationRuleEditorUtilityClass, classes);
};

const ExpirationRuleEditorRoot = styled('div', {
	name: EXPIRATION_RULE_EDITOR_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flex: '1 1 auto',
}));

export type ExpirationRuleEditorProps = WithClasses<
	ExpirationRuleEditorClasses,
	CommonRuleEditorProps & {}
>;

const ExpirationRuleEditorInner = ({
	classes: _classes,
	className,
}: ExpirationRuleEditorProps) => {
	const ownerState: ExpirationRuleEditorOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<ExpirationRuleEditorRoot
			className={clsx(classes.root, className)}
		></ExpirationRuleEditorRoot>
	);
};

export const ExpirationRuleEditorPrimitive = ExpirationRuleEditorInner;

export const ExpirationRuleEditor = ExpirationRuleEditorPrimitive;

export default ExpirationRuleEditor;
